module.exports = __webpack_public_path__ + "img/ma279.e7005332.png";